import { useLanguage } from "../hooks/useLanguage"

const rowStyles = [
  { anim: "gms-marquee", text: "font-semibold", dot: "bg-gms-accent" },
  { anim: "gms-marquee-rev", text: "font-medium text-[#71717A]", dot: "bg-gms-accent-mid" },
]

export default function StackMarquee() {
  const { t, language } = useLanguage()
  const rows = t.stack.rows
  const all = new Intl.ListFormat(language, { type: "conjunction" }).format(rows.flat())

  return (
    <section
      aria-labelledby="gms-stack-title"
      className="mt-[clamp(64px,7vw,96px)] border-y border-gms-line pb-8 pt-[30px]"
    >
      <h2 id="gms-stack-title" className="mb-[22px] flex items-center justify-center gap-2 font-mono text-[13px] font-normal text-gms-subtle">
        <span aria-hidden="true" className="h-[7px] w-[7px] rounded-[2px] bg-gms-accent" />
        {t.stack.title}
      </h2>
      <p className="sr-only">{all}.</p>

      <div aria-hidden="true" className="gms-stack gms-fade-x flex flex-col gap-4 overflow-hidden">
        {rows.map((items, r) => (
          <div key={r} className={`${rowStyles[r].anim} flex w-max`}>
            {/* Duas cópias iguais: a animação anda -50% e recomeça sem salto */}
            {[0, 1].map((copy) => (
              <div
                key={copy}
                className={`flex items-center gap-8 whitespace-nowrap pr-8 text-[clamp(22px,2.1vw,30px)] tracking-[-0.035em] ${rowStyles[r].text}`}
              >
                {items.map((name) => (
                  <span key={name} className="contents">
                    <span>{name}</span>
                    <span className={`h-[9px] w-[9px] rounded-[2px] ${rowStyles[r].dot}`} />
                  </span>
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  )
}
